import { render, staticRenderFns } from "./template-download.vue?vue&type=template&id=478e95ea&"
import script from "./template-download.vue?vue&type=script&lang=js&"
export * from "./template-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports